import React from 'react';
import { FacetLists } from './FacetLists';
type Props = {
  activeCustomFacets: any;
  activeFacets: any;
  facetsFromSearch: Array<SearchFacetCategory>;
  onChange: (name: string, checked: boolean, value: string | boolean) => void;
  templateConfig: FacetTemplateConfig;
};
export const FacetCategory = (props: Props) => {
  return <FacetLists {...props} />;
};
